export default {
  state: {
    cfg_dict_token_setting: {
      eth: {
        color: '#41FFFC',
        icon: 'eth.png',
      },
      axis: {
        color: '#EC5DFF',
        icon: 'axis.jpg',
      },
      usdt: {
        color: '#33C4AC',
        icon: 'usdt.png',
      },
    },

    // 说明：这里加币后，
    // 1 - web3.account_wallet 中要同步改配置
    // 2 - web3.account_wallet 要获取余额
    // 3 - app.vue 要获取该币对usd的价格
    // 4 - bid 字典可能也需要增加字典（下方 cfg_token_type_bid 字段）
    // 5 - buy 弹框中要判断新币的 hasApproveXXX approveXXX
    // 5 - bid 弹框中要判断新币的 hasApproveXXX approveXXX

    cfg_token_type_sell: [
      {
        id: 'eth',
        // name: 'ETH',
        name: 'BNB',
      },
      {
        id: 'axis',
        // name: 'AXIS',
        name: 'JGN',
      },
      {
        id: 'cake',
        name: 'CAKE',
      },
      // {
      //   id: 'usdt',
      //   name: 'USDT',
      // },
    ],
    cfg_token_type_bid: [
      {
        id: 'weth',
        name: 'WBNB',
      },
      {
        id: 'axis',
        name: 'JGN',
      },
      {
        id: 'cake',
        name: 'CAKE',
      },
    ],
    cate_sort_list: [
      {
        id: 'available_for_sale',
        name: {
          en: 'Available for sale',
          zh: '卖品',
        },
      },
      {
        id: 'most_liked',
        name: {
          en: 'Most liked',
          zh: '最受喜爱',
        },
      },
      {
        id: 'cheapest',
        name: {
          en: 'Cheapest',
          zh: '价格最低',
        },
      },
      {
        id: 'highest_price',
        name: {
          en: 'Highest price',
          zh: '价格最高',
        },
      },
      // {
      //   id: 'most_transactions',
      //   name: {
      //     en: 'Most transactions',
      //     zh: '交易最多',
      //   },
      // },
      {
        id: 'recently_added',
        name: {
          en: 'Recently added',
          zh: '最近添加',
        },
      },
      // {
      //   id: 'verified_only',
      //   name: {
      //     en: 'Verified only',
      //     zh: '已验证',
      //   },
      // },
    ],
  },
};
